import { HighlightOff, Info } from "@mui/icons-material";
import { Box, IconButton, Tooltip as MuiTooltip, Stack, styled, tooltipClasses, TooltipProps } from "@mui/material";
import React, { useState } from "react";

import { Typography } from "new-components/typography/Typography";

const CustomTooltip = styled(({ className, ...props }: TooltipProps) => (
  <MuiTooltip {...props} classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "white",
    color: "black",
    padding: "0px",
    maxWidth: "500px",
    [`@media (max-width:600px)`]: {
      maxWidth: "300px",
    },
    boxShadow: "4px 4px 20px 0px #00000040",
  },
}));

interface InfoTooltipContentProps {
  title: string;
  content: React.ReactNode;
  onClose: () => void;
}

export function InfoTooltipContent(props: InfoTooltipContentProps) {
  const { title, content, onClose } = props;
  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          backgroundColor: "#E5E9ED",
          padding: "8px",
        }}
      >
        <Info sx={{ color: "#919599" }} />
        <Typography sx={{ fontSize: "20px", lineHeight: "24px" }}>{title}</Typography>
        <IconButton onClick={onClose} sx={{ padding: "0px", color: "#919599" }}>
          <HighlightOff />
        </IconButton>
      </Box>
      <Stack sx={{ gap: "10px", padding: "20px" }}>{content}</Stack>
    </Box>
  );
}

interface InfoTooltipProps extends Omit<TooltipProps, "title" | "children"> {
  infoContentTitle: string;
  infoContent: React.ReactNode;
  children?: React.ReactElement;
}

export function InfoTooltip(props: InfoTooltipProps) {
  const { infoContentTitle, infoContent, children } = props;

  const [open, setOpen] = useState<boolean>(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const tooltipIcon = children || <Info sx={{ color: "#E5E9ED", cursor: "pointer" }} />;

  return (
    <CustomTooltip
      {...props}
      open={open}
      onClose={handleClose}
      onOpen={handleOpen}
      title={<InfoTooltipContent title={infoContentTitle} content={infoContent} onClose={handleClose} />}
    >
      {tooltipIcon}
    </CustomTooltip>
  );
}
